import Redirect from './Redirect'
import Action from './action'

export default { Auth : Redirect, Action }